module.exports = __webpack_public_path__ + "img/7fd95df.jpg";